import {
  CLEAR_PRODUCT_REPORT_ERROR,
  PRODUCT_REPORT_ERROR,
  PRODUCT_REPORT_ERROR_FULFILLED,
  PRODUCT_REPORT_ERROR_REJECTED,
} from 'b2b-apps/shop/product/redux/productReportError/actionTypes';
import {
  ClearProductReportErrorAction,
  ProductReportErrorAction,
  ProductReportErrorFulfilledAction,
  ProductReportErrorRejectedAction,
} from 'b2b-apps/shop/product/redux/productReportError/types';
import { ReportProductErrorDetails } from 'b2b-common/shop/product/api/Product.types';

const clearProductReportError = (): ClearProductReportErrorAction => ({
  type: CLEAR_PRODUCT_REPORT_ERROR,
});

const productReportError = (
  details: ReportProductErrorDetails,
): ProductReportErrorAction => ({
  type: PRODUCT_REPORT_ERROR,
  payload: details,
});

const productReportErrorFulfilled = (): ProductReportErrorFulfilledAction => ({
  type: PRODUCT_REPORT_ERROR_FULFILLED,
});

const productReportErrorRejected = (error: ErrorType): ProductReportErrorRejectedAction => ({
  type: PRODUCT_REPORT_ERROR_REJECTED,
  payload: {
    error,
  },
});

export {
  clearProductReportError,
  productReportError,
  productReportErrorFulfilled,
  productReportErrorRejected,
};
